import endpoints from "@/utils/constants";
import { apiHelper } from "@/utils/helpers";
import posUtil from "@/utils/PosProducts";
import { print } from "@/utils/print";

const actions = {
  createSale(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}${endpoints.API.sales}`,
          context.state.sale
        )
        .then(res => {
          if (res.status === 201) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getSales(context, payload) {
    const params = new URLSearchParams(payload).toString();
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", `${endpoints.BASE_URL}${endpoints.API.sales}?${params}`)
        .then(res => {
          if (res.status === 200) {
            context.commit("setSaleList", res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  editSale(context, saleId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", `${endpoints.BASE_URL}${endpoints.API.sales}/${saleId}`)
        .then(async res => {
          if (res.status === 200) {
            const products = await posUtil.transform(res.data.products);
            res.data.products = products;
            context.commit("setSale", res.data);
          }
          resolve(res.status);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateSale(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "put",
          `${endpoints.BASE_URL}${endpoints.API.sales}/${context.state.sale.saleId}`,
          context.state.sale
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getSaleTransactions(context, saleId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.sales}/${saleId}/sale-transactions`
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setSaleTransactions", res.data);
          }
        });
    });
  },

  createSaleTransaction(context, saleId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}${endpoints.API.sales}/${saleId}/sale-transactions`,
          context.state.saleTransaction
        )
        .then(res => {
          if (res.status === 201) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  addCreditNotes(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}${endpoints.API.sales}/${
            context.state.sale.saleId
          }/${"credit-notes"}`,
          context.state.sale
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getReceipt(context, saleId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.sales}/${saleId}/receipt`
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setReceiptData", res.data);
            print(res.data, "sale");
          }
          resolve(res.status);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default actions;
